import type { DiscoverBbox } from '@xingroute/schema'

// Web Mercator clamps lat at ±85.05112878 (πN). Discover API (parseBbox in
// apps/api/src/routes/routes.ts) rejects |lng|>180 / |lat|>90 with HTTP 400,
// so we must clamp Mapbox's wrapped bounds before publishing them upstream.
export const LNG_MIN = -180
export const LNG_MAX = 180
export const LAT_MIN = -85.05112878
export const LAT_MAX = 85.05112878

function clamp(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) return min
  if (value < min) return min
  if (value > max) return max
  return value
}

// Clamp a raw Mapbox bounds quadruple to the Web Mercator visible band so that
// the Discover API does not 400 at low zoom levels (where east > 180 etc.).
// When east < west after clamping (e.g. the viewport wraps the antimeridian)
// we widen to the full lng range so the API still returns sensible results.
export function clampBbox(west: number, south: number, east: number, north: number): DiscoverBbox {
  let w = clamp(west, LNG_MIN, LNG_MAX)
  let e = clamp(east, LNG_MIN, LNG_MAX)
  const s = clamp(south, LAT_MIN, LAT_MAX)
  const n = clamp(north, LAT_MIN, LAT_MAX)
  if (e < w) {
    w = LNG_MIN
    e = LNG_MAX
  }
  return [round(w), round(s), round(e), round(n)]
}

function round(value: number): number {
  return Math.round(value * 1e5) / 1e5
}
